/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */

/**
 * The fund source of this payout

- income
- household
- friends-loan
- company-fund
- personal-investment
- personal-savings
- wages

 */
export type CreatePayoutBodySourceOfFunds = typeof CreatePayoutBodySourceOfFunds[keyof typeof CreatePayoutBodySourceOfFunds];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreatePayoutBodySourceOfFunds = {
  income: 'income',
  household: 'household',
  'friends-loan': 'friends-loan',
  'company-fund': 'company-fund',
  'personal-investment': 'personal-investment',
  'personal-savings': 'personal-savings',
  wages: 'wages',
} as const;
